import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import { useForm } from 'react-hook-form';
import { showToastNotification } from '../../utility/helper';
import InputField from '../../components/UI/Forms/InputField';
import ErrorMessage from '../../components/UI/Notifications/ErrorMessage';
import Button from '../../components/UI/Buttons/Button';
import useConfirmationModal from '../../hooks/useConfirmationModal';
import ConfirmationModal from '../../components/UI/Modal/ConfirmationModal';
import useImageUpload from '../../hooks/useImageUpload';
import { IGift } from '../../interfaces/gift';
import useFileDelete from '../../hooks/useFileDelete';

const GiftHampers: React.FC = () => {
    const { uploadImage, error } = useImageUpload();
    const {deleteFile} = useFileDelete();
    const [gifts, setGifts] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm<IGift>({ mode: 'onBlur' });
    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [editingGift, setEditingGift] = useState<any | null>(null);
    const { showModal, modalProps, confirmAction } = useConfirmationModal();
    const [imageURL, setImageURL] = useState<string>('');

    const onSubmit = async (data: IGift) => {
        setLoadingButton(true);
        const postData = { name: data.name, minOrderAmount: data.minOrderAmount, image: imageURL };

        try {
            if (editingGift) {
                // Update gift
                await callApi(API_URL_2 + API_ENDPOINT.page + `gifts/${editingGift.id}`, { method: 'PUT', data: postData });
                showToastNotification('success', 'Gift updated successfully');
            } else {
                // Create new gift
                await callApi(API_URL_2 + API_ENDPOINT.page + 'gifts', { method: 'POST', data: postData });
                showToastNotification('success', 'Gift added successfully');
            }

            reset();
            setImageURL('')
            setEditingGift(null);
            getGifts();
        } catch (error: any) {
            showToastNotification('danger', error.message);
        } finally {
            setLoadingButton(false);
        }
    };

    useEffect(() => {
        getGifts();
    }, []);

    const getGifts = async () => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + 'gifts', { method: 'GET' });
            setGifts(response);
        } catch (error: any) {
            console.error('Failed to fetch gifts:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const deleteGift = async (id: string) => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + `gifts/${id}`, { method: 'DELETE' });
            setGifts((prevGifts: any[]) => prevGifts.filter((gift) => gift.id !== id));
        } catch (error: any) {
            console.error('Failed to delete gift:', error.message);
        }
    };

    const handleEditGift = (gift: any) => {
        setEditingGift(gift);
        setValue('name', gift.name);
        setValue('image', gift.image);
        setValue('minOrderAmount', gift.minOrderAmount);
        setImageURL(gift.image)
    };

    const handleDeleteClick = (id: string) => {
        confirmAction({
            title: 'Confirm Delete',
            message: 'Are you sure you want to delete this gift?',
            onConfirm: () => deleteGift(id),
        });
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
            const uploadedUrl = await uploadImage(file);
            setImageURL(uploadedUrl);
            setValue('image', uploadedUrl)
        } catch (err) {
            console.error(err);
        }
    };
    const handleDeleteImage =async (url: string) => {
        setImageURL('');
        await deleteFile(url);
    };

    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">Gift Hampers</h1>
                {/* <button className='btn app-btn-primary d-flex align-items-center gap-1'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                </svg> Add Gifts</button> */}
            </div>

            <div className="row">
                <div className="col-lg-8">
                    <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                        <div className="app-card-body">
                            <div className="table-responsive">
                                <table className="table app-table-hover mb-0 text-left">
                                    <thead>
                                        <tr>
                                            <th className="cell">S.no.</th>
                                            <th className="cell">Gift</th>
                                            <th className="cell">Minimum Order Amount</th>
                                            <th className="cell">Image</th>
                                            <th className="cell">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan={3}>Loading gifts...</td>
                                            </tr>
                                        ) : gifts.length === 0 ? (
                                            <tr>
                                                <td className="text-center" colSpan={3}>No gifts available to display.</td>
                                            </tr>
                                        ) : (
                                            gifts.map((gift, index) => (
                                                <tr key={gift.id}>
                                                    <td className="cell">#{index + 1}</td>
                                                    <td className="cell">{gift.name}</td>
                                                    <td className="cell">{gift.minOrderAmount}</td>
                                                    <td className="cell">
                                                        <div className="table-image">
                                                            <img className="img-image" src={gift.image} alt="" />
                                                        </div>
                                                    </td>
                                                    <td className="cell">
                                                        <div className=' d-flex align-items-center gap-1'>
                                                            <a className="btn btn-success px-2 py-1 text-white" href="javascript:void(0)" onClick={() => handleEditGift(gift)}><i className="bi bi-pen"></i></a>
                                                            <a className="btn btn-danger px-2 py-1 text-white" href="javascript:void(0)" onClick={() => handleDeleteClick(gift.id)}><i className="bi bi-trash3"></i></a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="app-card app-card-settings shadow-sm p-4">
                        <div className="app-card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="mb-3 col-12">
                                        <InputField
                                            type="text"
                                            register={register('name', { required: 'Gift is required' })}
                                            name="name"
                                            label="Gift Hamper Name"
                                            placeholder="Enter gift hamper name"
                                        />
                                        <ErrorMessage message={errors.name?.message?.toString()} />
                                    </div>
                                    {/* minOrderAmount */}
                                    <div className="mb-3 col-12">
                                        <InputField
                                            type="text"
                                            register={register('minOrderAmount', { required: 'Minimum order amount is required' })}
                                            name="minOrderAmount"
                                            label="Minimum Order Amount"
                                            placeholder="Enter minimum order amount"
                                        />
                                        <ErrorMessage message={errors.minOrderAmount?.message?.toString()} />
                                    </div>
                                    <div className="mb-3 col-12 image-upload">
                                        <div className='form-label'>
                                            Gift image
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <label htmlFor="file-input" className="choosefilenew position-relative">
                                                    <input
                                                        type="file"
                                                        className=''
                                                        id="file-input"
                                                        accept="image/*"
                                                        hidden
                                                        onChange={(e) => handleFileChange(e)}
                                                    />

                                                    <div><div className='mb-2'><i className="bi fs-4 bi-upload"></i></div>
                                                        Upload Image</div>
                                                </label>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <div className='addimagefiles w-100'>
                                                    {imageURL && (
                                                        <div className="image-card w-100">
                                                            <img src={imageURL} alt="Icon" className="image-preview w-100" />
                                                            <button type="button" className='btn btn-danger px-2 py-1 text-white position-absolute' onClick={() => handleDeleteImage(imageURL)}>
                                                                <i className='bi bi-trash3'></i>
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <ErrorMessage message={errors.image?.message?.toString()} />
                                        <ErrorMessage message={error?.toString()} />
                                    </div>

                                </div>
                                <div className="col-12 text-end mt-3 ">
                                    <Button loading={loadingButton} className="btn btn-primary text-white px-5" type="submit" text={editingGift ? 'Update' : 'Save'} />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    );
};

export default GiftHampers;
